(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["variant-main-picker"] && !Shopify.designMode) return;
  try {
    (function() {
    if (window.innerWidth > 749) return;

    document.querySelectorAll('.variant-option--dropdowns').forEach(function(container) {
      var selectWrapper = container.querySelector('.variant-option__select-wrapper');
      var overlay = container.querySelector('.ysl-mobile-size-overlay');
      if (!selectWrapper || !overlay) return;

      var targetId = overlay.getAttribute('data-target-select');
      var nativeSelect = document.getElementById(targetId);
      if (!nativeSelect) return;

      var backdrop = overlay.querySelector('.ysl-mobile-size-backdrop');
      var closeBtn = overlay.querySelector('.ysl-mobile-size-close');
      var options = overlay.querySelectorAll('.ysl-mobile-size-option');

      function openOverlay(e) {
        e.preventDefault();
        e.stopPropagation();
        overlay.style.display = '';
        document.body.style.overflow = 'hidden';
      }

      function closeOverlay() {
        overlay.style.display = 'none';
        document.body.style.overflow = '';
      }

      selectWrapper.addEventListener('click', openOverlay, true);
      backdrop.addEventListener('click', closeOverlay);
      closeBtn.addEventListener('click', closeOverlay);

      options.forEach(function(btn) {
        btn.addEventListener('click', function() {
          var val = btn.getAttribute('data-value');
          nativeSelect.value = val;
          nativeSelect.dispatchEvent(new Event('change', { bubbles: true }));
          options.forEach(function(b) { b.classList.remove('is-selected'); });
          btn.classList.add('is-selected');
          closeOverlay();
        });
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
